'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

var getStyleProp = exports.getStyleProp = function getStyleProp(key, applyOnReset) {
  return function (_ref) {
    var reset = _ref.reset,
        styleProps = _ref.styleProps;

    if (reset && !applyOnReset) {
      return undefined;
    }

    return styleProps[key];
  };
};

var hasEqualSides = exports.hasEqualSides = function hasEqualSides(props) {
  return props.round || props.square;
}; //


var borderRadiusStyleProp = function borderRadiusStyleProp() {
  return function (_ref2) {
    var styleProps = _ref2.styleProps,
        rest = _objectWithoutProperties(_ref2, ['styleProps']);

    if (rest.round) {
      return '50%';
    }

    return getStyleProp('borderRadius')({
      styleProps: styleProps
    });
  };
};

exports.borderRadiusStyleProp = borderRadiusStyleProp;

var paddingStyleProp = function paddingStyleProp() {
  return function (_ref3) {
    var styleProps = _ref3.styleProps,
        rest = _objectWithoutProperties(_ref3, ['styleProps']);

    if (rest.reset || hasEqualSides(rest)) {
      return undefined;
    }

    return getStyleProp('padding', true)({
      styleProps: styleProps
    });
  };
};

exports.paddingStyleProp = paddingStyleProp;

var squareStyleProp = function squareStyleProp(isWidth) {
  return function (_ref4) {
    var styleProps = _ref4.styleProps,
        rest = _objectWithoutProperties(_ref4, ['styleProps']);

    if (hasEqualSides(rest)) {
      return '2em';
    }

    return getStyleProp(isWidth ? 'width' : 'height')({
      styleProps: styleProps
    });
  };
};

exports.squareStyleProp = squareStyleProp;